import { warn } from '../../../logger';
import { InternalElementFactoryOptions, SdkElement } from '../../../model';
import { recordEvent } from '../../../telemetry';
import { SDKError } from '../../error';
import { LRSElement, LRSElementOptions } from './LRSElement';
import { parseLRSOptions } from './lrsOptionsSchema';

export const createLRSElement = async (
  elementOptions: LRSElementOptions,
  commonOptions: InternalElementFactoryOptions
): Promise<SdkElement> => {
  await recordEvent('sdk_lrs_element_init_options', {
    lrs_element_options: { ...elementOptions },
    elements_options: commonOptions
  });

  const {
    errors,
    warnings,
    options: validatedOptions,
    initialOptions
  } = parseLRSOptions(elementOptions);

  if (errors) {
    throw new SDKError('invalidLRSElementOptions', 'Invalid LRS Element options provided.', errors);
  }

  if (warnings) {
    warn('invalidLRSElementOptions', warnings);
  }

  await recordEvent('sdk_lrs_element_options_validated', {
    lrs_element_warnings: warnings,
    lrs_element_options: initialOptions,
    elements_options: commonOptions
  });

  return LRSElement({ ...validatedOptions, ...commonOptions });
};
